import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import './nav.css'
import styles from './nav.module.css'

function Navb() {
    const navigate = useNavigate();
    const [scrolled, setScrolled] = useState(false);

    // Carga el idioma guardado al inicio
    useEffect(() => {
        const savedLanguage = localStorage.getItem('preferredLanguage');
        if (savedLanguage) {
            navigate(`/${savedLanguage}`);
        }
    }, [navigate]);

    useEffect(() => {
        const handleScroll = () => {
          const isScrolled = window.scrollY > 50; // Cambia el número si quieres más o menos scroll
            setScrolled(isScrolled);
        };
    
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
        }, []);

    // Cambia el idioma y redirige
    const handleLanguageChange = (language) => {
        localStorage.setItem('preferredLanguage', language);
        navigate(`/${language}`);
    };
return (
<Navbar
    collapseOnSelect
    expand="lg"
    className={`${styles.bgnav} ${scrolled ? styles.navbarScrolled : styles.navbarTransparent}`}>
    <Container>
    <Navbar.Brand href="#home" className={styles.logo}>LAUTARO MAZZA</Navbar.Brand>
    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
    <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="ms-auto">
        <Nav.Link href="#sobremi" className={styles.navitem}>SOBRE MI</Nav.Link>
        <Nav.Link href="#galeria" className={styles.navitem}>GALERIA</Nav.Link>
        <Nav.Link href="#clases" className={styles.navitem}>CLASES Y TALLERES</Nav.Link>
        <Nav.Link href="#eventosprivados" className={styles.navitem}>EVENTOS PRIVADOS</Nav.Link>
        <Nav.Link href="#prensa" className={styles.navitem}>PRENSA Y MEDIOS</Nav.Link>
        <Nav.Link href="#contacto" className={styles.navitem}>CONTACTO</Nav.Link>
        <NavDropdown className={styles.navitem} title="IDIOMA" id="basic-nav-dropdown">
            <NavDropdown.Item onClick={() => handleLanguageChange('es')}>ESPAÑOL</NavDropdown.Item>
            <NavDropdown.Item onClick={() => handleLanguageChange('en')}>
            INGLES
            </NavDropdown.Item>
        </NavDropdown>
        </Nav>
    </Navbar.Collapse>
    </Container>
</Navbar>
);
}

export default Navb;